(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/views/pages/play-page.js') >= 0) return;  svs.modules.push('/modules/lotto/views/pages/play-page.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.lotto=_svs.lotto||{};
_svs.lotto.templates=_svs.lotto.templates||{};
svs.lotto.templates.play_page = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div id=\"ngRowsContainerRegion\">\n    <div class=\"ng-skeleton-content\">\n      <div class=\"skeleton-ball-rows col-xs-12 col-sm-10 col-md-4 margin-top-4\">\n"
    + ((stack1 = (lookupProperty(helpers,"for")||(depth0 && lookupProperty(depth0,"for"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),1,8,{"name":"for","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":8},"end":{"line":17,"column":16}}})) != null ? stack1 : "")
    + "      </div>\n    </div>\n  </div>\n";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"skeleton-ball-row ball-row\" data-size=\"200\">\n            <div class=\"ball-row-inner\">\n              <div class=\"ball-row-numbers\">\n"
    + ((stack1 = (lookupProperty(helpers,"for")||(depth0 && lookupProperty(depth0,"for"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),1,7,{"name":"for","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":16},"end":{"line":13,"column":24}}})) != null ? stack1 : "")
    + "              </div>\n            </div>\n          </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "                  <div class=\"ball ball-lotto\">\n                    <div class=\"ball-bg\"></div>\n                  </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"numbergames")||(depth0 && lookupProperty(depth0,"numbergames"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"game-app/hammock",{"name":"numbergames","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":21,"column":16}}})) != null ? stack1 : "")
    + "<div class=\"gutter-xs-1 gutter-md-2\">\n  <div id=\"ngBetslipRegion\" class=\"grid-row padding-xs-h-1 padding-md-h-2\"></div>\n</div>\n<div id=\"ngPayfooterRegion\" class=\"ng-payfooter-wrapper\"></div>\n\n\n\n\n";
},"useData":true});
Handlebars.partials['svs-lotto-play_page'] = svs.lotto.templates.play_page;
})(svs, Handlebars);


 })(window);